import { createSignal, createMemo, onMount, For, Show, onCleanup } from 'solid-js';
import styles from './Weihnachten.module.css';
import { useApi, isOk } from '../../api';


export default function Weihnachten() {
	const api = useApi();
	const [mapping, setMapping] = createSignal<Record<string, string>>({});
    const [revealed, setRevealed] = createSignal<boolean[]>([false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]);

	const now = new Date();
	const year = now.getFullYear();
	const isDecember = now.getMonth() === 11;
	const todayDate = now.getDate();

	async function loadMapping() {
		try {
			const res = await api.xdsm.getWeihnachten();
			if (isOk(res.data)) {
				setMapping((res.data.value.names ?? {}) as Record<string, string>);
			}
		} catch (_e: any) {
		}
	}

	onMount(() => {
		loadMapping();
	});

function NextDayCountdown() {
	const [timeLeft, setTimeLeft] = createSignal({ h: 0, m: 0, s: 0 });

	function compute() {
		const now = new Date();
		const next = new Date(now);
		next.setDate(now.getDate() + 1);
		next.setHours(0, 0, 0, 0);
		const diff = next.getTime() - now.getTime();
		if (diff <= 0) return { h: 0, m: 0, s: 0 };
		const h = Math.floor(diff / 3600000);
		const m = Math.floor((diff % 3600000) / 60000);
		const s = Math.floor((diff % 60000) / 1000);
		return { h, m, s };
	}

	onMount(() => {
		setTimeLeft(compute());
		const id = setInterval(() => setTimeLeft(compute()), 1000);
		onCleanup(() => clearInterval(id));
	});

	const pad = (n: number) => String(n).padStart(2, '0');

	return (
		<div class={styles.countdown} aria-live="polite">
			<span class={styles.countdownIcon} aria-hidden>⏰</span>
			<span class={styles.countdownLabel}>Nächstes Türchen in</span>
			<span class={styles.countdownTime}>{pad(timeLeft().h)}:{pad(timeLeft().m)}:{pad(timeLeft().s)}</span>
		</div>
	);
}

	const entries = createMemo(() => {
		return Array.from({ length: 24 }, (_, i) => {
			const day = i + 1;
			return { day, name: mapping()[String(day)] };
		});
	});

	return (
		<div class={styles.container}>
			<header class={styles.header}>
				<h1>DSM Clan: Adventskalender</h1>
				<p style={"color:white;font-weight:600"}>Vom 1. bis 24. Dezember wird täglich ein Name gezogen und erhält eine Belohnung.</p>
			</header>

			<NextDayCountdown />
				<br></br>

			<main>
				<div class={styles.grid} role="list">
					<For each={entries()}>{(e) => {
						const unlocked = isDecember && e.day <= todayDate;
                        const revealedState = () => revealed()[index];
						const name = e.name;
                        const index = e.day - 1;
						return (
							<div class={styles.box} role="listitem">
								<div onClick={() => {
                                    if (unlocked) {
										let img = document.getElementById(index + "img") as HTMLImageElement;
										if (img) {
											img.src = `/export.svg?_=${performance.now()}`;
										}
                                        setTimeout(() => {
											let img = document.getElementById(index + "img") as HTMLImageElement;
											if (img) {
												img.remove();
											}
											setRevealed(prev => {
                                            	const copy = [...prev];
                                            	copy[index] = true;
                                            	return copy;
                                        	});
										}, 4100);
                                    }
                                }} style={(unlocked ? '' : ' filter: brightness(0.7);')} class={styles.boxInner + ' ' + (revealedState() ? styles.revealed : styles.locked)}>
									<div class={styles.day}>{e.day}</div>
									<Show when={!revealedState()}>
                                        <Show when={unlocked && name} fallback={<img src="/exportframe.svg" class={styles.animate}></img>}>
                                            <img id={index + "img"} src="/exportframe.svg" class={styles.animate}></img>
									    </Show>

                                    </Show>
                                    <Show when={revealedState()}>
                                        <div class={styles.gift}>🎁</div>
                                        <div class={styles.winner} title={`Gewinner vom ${e.day}. Dezember`}>{name}</div>
									</Show>
								</div>
							</div>
						);
					}}</For>
				</div>
			</main>

			<footer class={styles.footer}>
				<div>DSM: Viel Spaß und frohe Weihnachten!</div>
				<div class={styles.small}>Jahr: {year}</div>
			</footer>
		</div>
	);
}

